import { FC } from 'react';

type GeoIcon2Props = {
  width?: number | string;
  height?: number | string;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const GeoIcon2: FC<GeoIcon2Props> = ({
  width = 16,
  height = 16,
  color = '#BB9583',
  ...rest
}) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M4.6665 12C3.44722 12.2745 2.6665 12.6962 2.6665 13.1691C2.6665 13.9962 5.05432 14.6667 7.99984 14.6667C10.9454 14.6667 13.3332 13.9962 13.3332 13.1691C13.3332 12.6962 12.5524 12.2745 11.3332 12" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
    <path d="M9.66683 5.99999C9.66683 6.92046 8.92063 7.66666 8.00016 7.66666C7.0797 7.66666 6.3335 6.92046 6.3335 5.99999C6.3335 5.07952 7.0797 4.33333 8.00016 4.33333C8.92063 4.33333 9.66683 5.07952 9.66683 5.99999Z" stroke={color} strokeWidth="1.4"/>
    <path d="M8.83843 11.6624C8.61356 11.8789 8.31303 12 8.0003 12C7.6875 12 7.38696 11.8789 7.1621 11.6624C5.10303 9.6672 2.34362 7.43833 3.6893 4.20248C4.4169 2.45288 6.16346 1.33333 8.0003 1.33333C9.8371 1.33333 11.5836 2.45288 12.3112 4.20248C13.6552 7.43426 10.9026 9.67406 8.83843 11.6624Z" stroke={color} strokeWidth="1.4"/>
  </svg>
);

